import CountryDetails from './CountryDetails';

export default CountryDetails;
